import { initSentry } from '@imt/vue-toolbox/src/plugins/sentry';
import * as Sentry from '@sentry/vue';
import Vue from 'vue';

initSentry({
    Vue,
    dsn: 'https://2c5c9bf11cca400e83522c657340771d@o527262.ingest.sentry.io/5658871',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.vueIntegration({
            tracingOptions: {
                trackComponents: true,
            },
        }),
    ],
    tracesSampleRate: 1.0,
});
